export const hostName = process.env.NEXT_PUBLIC_HOST_URL
export const hostPrefixApi = process.env.NEXT_PUBLIC_HOST_PREFIX_API
export const alphaUrl = process.env.NEXT_PUBLIC_ALPHA_URL
export const photosUrl = `https://${process.env.NEXT_PHOTOS_DOMAIN}/images`
export const documentsUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/documents`
